export const HEADER = `/* tslint:disable */\n/* This file is generated; do not edit */`
